export default "/_next/static/images/contentful-0a708178727ec9e419e1bad0b5cdbade.png";